<template>
  <v-card flat>
    <!-- <v-card-title>
      <div>
        <div class="headline">General</div>
      </div>
    </v-card-title> -->
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="newScheme">mdi-plus</v-icon>
      <v-icon v-else-if="query">mdi-magnify</v-icon>
      <v-icon v-else>mdi-pencil</v-icon>
      <v-toolbar-title v-if="newScheme">Create New Scheme</v-toolbar-title>
      <v-toolbar-title v-else-if="query">Query Scheme</v-toolbar-title>
      <v-toolbar-title v-else>Edit Scheme</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!newScheme" color="primary" @click="$router.push('polTypeScheme')">
        Permitted Policy Type
        <v-icon right>mdi-view-list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6 v-if="newScheme">
            <v-text-field
              :label="labels.scheme"
              v-model="schemeForm.scheme"
              :error-messages="errors.collect('scheme')"
              data-vv-name="scheme"
              :data-vv-as="labels.scheme"
              v-validate="'required|param|max:4'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              :label="labels.scheme"
              v-model="schemeForm.scheme"
              :error-messages="errors.collect('scheme')"
              data-vv-name="scheme"
              :data-vv-as="labels.scheme"
              v-validate="'required|param|max:4'"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newScheme">
            <cal-picker
              :label="labels.effDate"
              v-model="schemeForm.effDate"
              :error-messages="errors.collect('effDate')"
              data-vv-name="effDate"
              :max="schemeForm.expDate"
              :data-vv-as="labels.effDate"
              v-validate="'required'"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker
              :label="labels.effDate"
              v-model="schemeForm.effDate"
              :error-messages="errors.collect('effDate')"
              data-vv-name="effDate"
              :max="schemeForm.expDate"
              :data-vv-as="labels.effDate"
              v-validate="'required'"
              disabled
            ></cal-picker>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <cal-picker
              :label="labels.expDate"
              v-model="schemeForm.expDate"
              :error-messages="errors.collect('expDate')"
              data-vv-name="expDate"
              :min="minExpDate(schemeForm.effDate)"
              :data-vv-as="labels.expDate"
              v-validate="validateExpDate(schemeForm.effDate)"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker
              :label="labels.expDate"
              v-model="schemeForm.expDate"
              :error-messages="errors.collect('expDate')"
              data-vv-name="expDate"
              :min="minExpDate(schemeForm.effDate)"
              :data-vv-as="labels.expDate"
              v-validate="validateExpDate(schemeForm.effDate)"
              disabled
            ></cal-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-if="!queryMode">
            <v-text-field
              :label="labels.schemeDesc"
              v-model="schemeForm.schemeDesc"
              :error-messages="errors.collect('schemeDesc')"
              data-vv-name="schemeDesc"
              :data-vv-as="labels.schemeDesc"
              v-validate="'required|max:40'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              :label="labels.schemeDesc"
              v-model="schemeForm.schemeDesc"
              :error-messages="errors.collect('schemeDesc')"
              data-vv-name="schemeDesc"
              :data-vv-as="labels.schemeDesc"
              v-validate="'required|max:40'"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-autocomplete
              :items="schemeTypeList"
              v-model="schemeForm.schemeType"
              :label="labels.schemeType"
              item-text="label"
              item-value="value"
              data-vv-name="schemeType"
              :data-vv-as="labels.schemeType"
              :error-messages="errors.collect('schemeType')"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :items="schemeTypeList"
              v-model="schemeForm.schemeType"
              :label="labels.schemeType"
              item-text="label"
              item-value="value"
              data-vv-name="schemeType"
              :data-vv-as="labels.schemeType"
              :error-messages="errors.collect('schemeType')"
              v-validate="'required'"
              readonly
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-autocomplete
              :items="multiRiskBenList"
              v-model="schemeForm.multiRiskBen"
              :label="labels.multiRiskBen"
              item-text="label"
              item-value="value"
              data-vv-name="multiRiskBen"
              :data-vv-as="labels.multiRiskBen"
              :error-messages="errors.collect('multiRiskBen')"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :items="multiRiskBenList"
              v-model="schemeForm.multiRiskBen"
              :label="labels.multiRiskBen"
              item-text="label"
              item-value="value"
              data-vv-name="multiRiskBen"
              :data-vv-as="labels.multiRiskBen"
              :error-messages="errors.collect('multiRiskBen')"
              v-validate="'required'"
              readonly
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-autocomplete
              :items="polTermList"
              v-model="schemeForm.polTerm"
              :label="labels.polTerm"
              item-text="label"
              item-value="value"
              data-vv-name="polTerm"
              :data-vv-as="labels.polTerm"
              :error-messages="errors.collect('polTerm')"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :items="polTermList"
              v-model="schemeForm.polTerm"
              :label="labels.polTerm"
              item-text="label"
              item-value="value"
              data-vv-name="polTerm"
              :data-vv-as="labels.polTerm"
              :error-messages="errors.collect('polTerm')"
              readonly
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-autocomplete
              :items="annPerPremList"
              v-model="schemeForm.annPerPrem"
              :label="labels.annPerPrem"
              item-text="label"
              item-value="value"
              data-vv-name="annPerPrem"
              :data-vv-as="labels.annPerPrem"
              :error-messages="errors.collect('annPerPrem')"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :items="annPerPremList"
              v-model="schemeForm.annPerPrem"
              :label="labels.annPerPrem"
              item-text="label"
              item-value="value"
              data-vv-name="annPerPrem"
              :data-vv-as="labels.annPerPrem"
              :error-messages="errors.collect('annPerPrem')"
              v-validate="'required'"
              readonly
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-autocomplete
              :items="polTypeList"
              v-model="schemeForm.defPolType"
              :label="labels.defPolType"
              item-text="label"
              item-value="value"
              data-vv-name="defPolType"
              :data-vv-as="labels.defPolType"
              :error-messages="errors.collect('defPolType')"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete
              :items="polTypeList"
              v-model="schemeForm.defPolType"
              :label="labels.defPolType"
              item-text="label"
              item-value="value"
              data-vv-name="defPolType"
              :data-vv-as="labels.defPolType"
              :error-messages="errors.collect('defPolType')"
              readonly
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.freeCvrMth"
              type="number"
              :label="labels.freeCvrMth"
              :error-messages="errors.collect('freeCvrMth')"
              data-vv-name="freeCvrMth"
              :data-vv-as="labels.freeCvrMth"
              v-validate="'required|numeric'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.freeCvrMth"
              type="number"
              :label="labels.freeCvrMth"
              :error-messages="errors.collect('freeCvrMth')"
              data-vv-name="freeCvrMth"
              :data-vv-as="labels.freeCvrMth"
              v-validate="'required|numeric'"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.minInsdAge"
              type="number"
              :label="labels.minInsdAge"
              :error-messages="errors.collect('minInsdAge')"
              data-vv-name="minInsdAge"
              :data-vv-as="labels.minInsdAge"
              v-validate="'required|numeric'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.minInsdAge"
              type="number"
              :label="labels.minInsdAge"
              :error-messages="errors.collect('minInsdAge')"
              data-vv-name="minInsdAge"
              :data-vv-as="labels.minInsdAge"
              v-validate="'required|numeric'"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.maxInsdAge"
              type="number"
              :label="labels.maxInsdAge"
              :error-messages="errors.collect('maxInsdAge')"
              data-vv-name="maxInsdAge"
              :data-vv-as="labels.maxInsdAge"
              v-validate="'required|numeric|min_value:' + schemeForm.minInsdAge"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.maxInsdAge"
              type="number"
              :label="labels.maxInsdAge"
              :error-messages="errors.collect('maxInsdAge')"
              data-vv-name="maxInsdAge"
              :data-vv-as="labels.maxInsdAge"
              v-validate="'required|numeric|min_value:' + schemeForm.minInsdAge"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.maxInsdRenAge"
              type="number"
              :label="labels.maxInsdRenAge"
              :error-messages="errors.collect('maxInsdRenAge')"
              data-vv-name="maxInsdRenAge"
              :data-vv-as="labels.maxInsdRenAge"
              v-validate="'required|numeric'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.maxInsdRenAge"
              type="number"
              :label="labels.maxInsdRenAge"
              :error-messages="errors.collect('maxInsdRenAge')"
              data-vv-name="maxInsdRenAge"
              :data-vv-as="labels.maxInsdRenAge"
              v-validate="'required|numeric'"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.maxChildAge"
              type="number"
              :label="labels.maxChildAge"
              :error-messages="errors.collect('maxChildAge')"
              data-vv-name="maxChildAge"
              :data-vv-as="labels.maxChildAge"
              v-validate="'required|numeric'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.maxChildAge"
              type="number"
              :label="labels.maxChildAge"
              :error-messages="errors.collect('maxChildAge')"
              data-vv-name="maxChildAge"
              :data-vv-as="labels.maxChildAge"
              v-validate="'required|numeric'"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-text-field
              v-model="schemeForm.maxStdentAge"
              type="number"
              :label="labels.maxStdentAge"
              :error-messages="errors.collect('maxStdentAge')"
              data-vv-name="maxStdentAge"
              :data-vv-as="labels.maxStdentAge"
              v-validate="'required|numeric'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field
              v-model="schemeForm.maxStdentAge"
              type="number"
              :label="labels.maxStdentAge"
              :error-messages="errors.collect('maxStdentAge')"
              data-vv-name="maxStdentAge"
              :data-vv-as="labels.maxStdentAge"
              v-validate="'required|numeric'"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="!queryMode">
            <v-checkbox
              v-model="schemeForm.allowCoripanel"
              :label="labels.allowCoripanel"
              :error-messages="errors.collect('allowCoripanel')"
              data-vv-name="allowCoripanel"
              :data-vv-as="labels.allowCoripanel"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-checkbox
              v-model="schemeForm.allowCoripanel"
              :label="labels.allowCoripanel"
              :error-messages="errors.collect('allowCoripanel')"
              data-vv-name="allowCoripanel"
              :data-vv-as="labels.allowCoripanel"
              hide-details
              disabled
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-checkbox
              v-model="schemeForm.allowSubDet"
              :label="labels.allowSubDet"
              :error-messages="errors.collect('allowSubDet')"
              data-vv-name="allowSubDet"
              :data-vv-as="labels.allowSubDet"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-checkbox
              v-model="schemeForm.allowSubDet"
              :label="labels.allowSubDet"
              :error-messages="errors.collect('allowSubDet')"
              data-vv-name="allowSubDet"
              :data-vv-as="labels.allowSubDet"
              hide-details
              disabled
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-show="false" v-if="!queryMode">
            <v-checkbox
              v-model="schemeForm.allowInsd"
              :label="labels.allowInsd"
              :error-messages="errors.collect('allowInsd')"
              data-vv-name="allowInsd"
              :data-vv-as="labels.allowInsd"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-checkbox
              v-model="schemeForm.allowInsd"
              :label="labels.allowInsd"
              :error-messages="errors.collect('allowInsd')"
              data-vv-name="allowInsd"
              :data-vv-as="labels.allowInsd"
              hide-details
              disabled
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="!queryMode">
            <v-checkbox
              v-model="schemeForm.isPkgScheme"
              :label="labels.isPkgScheme"
              :error-messages="errors.collect('isPkgScheme')"
              data-vv-name="isPkgScheme"
              :data-vv-as="labels.isPkgScheme"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-checkbox
              v-model="schemeForm.isPkgScheme"
              :label="labels.isPkgScheme"
              :error-messages="errors.collect('isPkgScheme')"
              data-vv-name="isPkgScheme"
              :data-vv-as="labels.isPkgScheme"
              hide-details
              disabled
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ schemeForm.createdName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(schemeForm.createdDate) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!newScheme">
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ schemeForm.modifiedName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(schemeForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-spacer class="mt-3"></v-spacer>
      <v-layout>
        <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
          Cancel
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-flex lg6 md12 xs12 v-if="!queryMode">
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
            {{ newScheme ? 'Save Scheme' : 'Save Scheme' }}
            <v-icon right>{{ newScheme ? 'mdi-content-save' : 'mdi-content-save' }}</v-icon>
          </v-btn>
        </v-flex>
       </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { parseISO } from 'date-fns'

export default {
  data() {
    return {
      toogleArray: [true, false],
      labels: {
        scheme: 'Scheme Code',
        schemeDesc: 'Description',
        schemeType: 'Scheme Type',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        freeCvrMth: 'No of Free Cover (Months)',
        allowCoripanel: 'Allow Coinsurance/Reinsurance Panel',
        allowSubDet: 'Allow Subsidiary Details',
        allowInsd: 'Allow Insured Person',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        polTerm: 'Default Policy Term',
        annPerPrem: 'Annual/Period Premium',
        defPolType: 'Default Policy Type',
        multiRiskBen: 'Multiple Risks/Benefits per Plan',
        isPkgScheme: 'is Package Scheme',
        minInsdAge: 'Minimum Insured Age',
        maxInsdAge: 'Maximum Insured Age',
        maxInsdRenAge: 'Maximum Insured Renewal Age',
        maxChildAge: 'Maximum Child Age',
        maxStdentAge: 'Maximum Student Age'
      },
      schemeForm: {
        scheme: null,
        schemeDesc: null,
        schemeType: null,
        effDate: null,
        expDate: null,
        freeCvrMth: 0,
        allowCoripanel: false,
        allowSubDet: false,
        allowInsd: false,
        polTerm: 'A',
        annPerPrem: 'A',
        defPolType: null,
        multiRiskBen: 'R',
        isPkgScheme: true,
        minInsdAge: 0,
        maxInsdAge: 0,
        maxInsdRenAge: 0,
        maxChildAge: 0,
        maxStdentAge: 0,
        // Audit
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: null,
        modifiedDate: null
      },
      polTypeList: [],
      today: new Date(),
      newScheme: false,
      submitting: false,
      expandPanel: false,
      loading: true,
      queryMode: false
    }
  },
  computed: {
    schMenu() {
      return this.$store.state.pkgParam.scheme.menu
    },
    schemeTypeList() {
      return [
        { label: 'P - Personal', value: 'P' },
        { label: 'C - Commercial', value: 'C' }
      ]
    },
    multiRiskBenList() {
      return [
        { label: 'R - Risks', value: 'R' },
        { label: 'B - Benefits', value: 'B' }
      ]
    },
    annPerPremList() {
      return [
        { label: 'A - Annual', value: 'A' },
        { label: 'P - Period', value: 'P' }
      ]
    },
    polTermList() {
      return [
        { label: 'A - Annually', value: 'A' },
        { label: 'M - Monthly', value: 'M' },
        { label: 'B - Bi-monthly', value: 'B' },
        { label: 'T - Triannual', value: 'T' },
        { label: 'S - Semi-annually', value: 'S' }
      ]
    }
  },
  methods: {
    minExpDate(xDate) {
      if (this.newScheme) {
        return this.schemeForm.effDate
      } else {
        if (xDate) {
          return parseISO(xDate)
        }
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    validateExpDate(xDate) {
      return 'checkMinDate:' + xDate
    },
    async fetchData() {
      if (this.$store.state.pkgParam.scheme.init !== 1) {
        await this.$store.dispatch('schemeInit')
      }
      const apiURI = this.schMenu.getScheme
      if (apiURI) {
        try {
          this.loading = true
          const expand = { scheme: this.scheme }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.schemeForm.scheme = data.scheme.scheme
            this.schemeForm.schemeDesc = data.scheme.schemeDesc
            this.schemeForm.schemeType = data.scheme.schemeType
            this.schemeForm.effDate = data.scheme.effDate
            this.schemeForm.expDate = data.scheme.expDate
            this.schemeForm.freeCvrMth = data.scheme.freeCvrMth
            this.schemeForm.allowCoripanel = data.scheme.allowCoripanel
            this.schemeForm.allowSubDet = data.scheme.allowSubDet
            this.schemeForm.allowInsd = data.scheme.allowInsd
            this.schemeForm.polTerm = data.scheme.polTerm
            this.schemeForm.annPerPrem = data.scheme.annPerPrem
            this.schemeForm.defPolType = data.scheme.defPolType
            this.schemeForm.multiRiskBen = data.scheme.multiRiskBen
            this.schemeForm.isPkgScheme = data.scheme.isPkgScheme
            this.schemeForm.minInsdAge = data.scheme.minInsdAge
            this.schemeForm.maxInsdAge = data.scheme.maxInsdAge
            this.schemeForm.maxInsdRenAge = data.scheme.maxInsdRenAge
            this.schemeForm.maxChildAge = data.scheme.maxChildAge
            this.schemeForm.maxStdentAge = data.scheme.maxStdentAge
            this.schemeForm.createdName = data.scheme.createdName
            this.schemeForm.createdDate = data.scheme.createdDate
            this.schemeForm.modifiedName = data.scheme.modifiedName
            this.schemeForm.modifiedDate = data.scheme.modifiedDate
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getPolTypeList() {
      const apiURI = this.schMenu.getPolTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.polTypeList = []
        if (data) {
          this.polTypeList = data
        }
      }
    },
    doBack() {
      this.$router.push({ name: 'scheme' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newScheme) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.schMenu.updateScheme
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.schemeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'scheme' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    async doCreate() {
      const apiURI = this.schMenu.createScheme
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.schemeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'scheme' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'scheme' })
    }
  },
  created() {
    this.getPolTypeList()
    if (this.scheme !== 'new') {
      this.newScheme = false
      this.fetchData()
    } else {
      this.newScheme = true
    }
    if (this.query) {
      this.queryMode = true
    }
    const checkMinDate = {
      getMessage: (field, args) => {
        if (field === 'Expiry Date') {
          return 'Must be a later Effective Date'
        }
        return field + ' cannot be a past date'
      },
      validate: (value, args) => {
        if (value) {
          if (args.length > 0) {
            return removeTime(value) >= removeTime(args)
          } else {
            return removeTime(value) >= removeTime(new Date())
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkMinDate', checkMinDate)
  },
  props: ['scheme', 'query'],
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
</style>
